module.exports = __webpack_public_path__ + "img/system-cn.49391058.png";